import React from 'react';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import LegalPage from '../../components/Legal/LegalPage';

/** /kvkk — KVKK Aydınlatma Metni */
export const KvkkPage = () => <LegalPage ns="legal.kvkk" docKey="kvkk" icon={<PrivacyTipOutlinedIcon />} />;

/** /ticari-ileti-onayi — Ticari Elektronik İleti Onay Metni */
export const CommercialConsentPage = () => (
  <LegalPage ns="legal.commercialConsent" docKey="commercialConsent" icon={<MarkEmailReadOutlinedIcon />} />
);

/** /acik-riza — Açık Rıza Metni */
export const ExplicitConsentPage = () => (
  <LegalPage ns="legal.explicitConsent" docKey="explicitConsent" icon={<TaskAltOutlinedIcon />} />
);

/** /crm-sozlesmesi — CRM Hizmet Sözleşmesi ve Veri İşleme Eki */
export const CrmAgreementPage = () => (
  <LegalPage ns="legal.crmAgreement" docKey="crmAgreement" icon={<HandshakeOutlinedIcon />} />
);

/** /crm-aydinlatma — CRM Personel Aydınlatma Metni */
export const CrmNoticePage = () => <LegalPage ns="legal.crmNotice" docKey="crmNotice" icon={<BadgeOutlinedIcon />} />;
